import {AfterViewInit, Component, Input, ChangeDetectionStrategy} from "@angular/core";
import {BrightnessContrastComponent} from "./brightness-contrast.component";
import {ToolbarService} from "../../services/internal-services/toolbar.service";
import {MapService} from "../../services/internal-services/map.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-phoenix-brightness-contrast",
  templateUrl: "./brightness-contrast.component.html",
  styleUrls: ["./brightness-contrast.component.scss"],
  standalone: false,
})
export class PhoenixBrightnessContrastComponent extends BrightnessContrastComponent implements AfterViewInit {
    private _mode: any;

    brightnessEnabled = true;

    @Input() set enabledTool(tool: string) {
        this.displayPanel = this.toolbarOption === tool;
    }

    @Input() set mode(mode: any) {
        this._mode = mode;
    }

    get mode(): any {
        return this._mode;
    }

    constructor(mapService: MapService, toolbarService: ToolbarService) {
        super(mapService, toolbarService);
    }
}
